import { LogoutRequest } from '@/components/types';
import { api } from '@cems-eco/core/src/services/api';

export abstract class BaseTopMenuApi {

    
    constructor() {
    }

    async getSite(id: any): Promise<any> {
        return await api.get<any>(`/site/${id}`);
    }


    async logout(data: LogoutRequest): Promise<any> {
        return await api.post<any>(`/auth/logout`, data);
    }

}
